import { FLAG_TIER_COLOR } from "./types.js";
import { formatFlagDetail, formatFlagLabel, getFlagTier } from "./flag-helpers.js";
import "react";
import { Badge, Tooltip } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Scheduling/shared/shift-flags/ShiftFlagBadge.tsx
function ShiftFlagBadge({ flag }) {
	return /* @__PURE__ */ jsx(Tooltip, {
		tooltip: formatFlagDetail(flag),
		children: /* @__PURE__ */ jsx(Badge, {
			color: FLAG_TIER_COLOR[getFlagTier(flag)],
			value: formatFlagLabel(flag)
		})
	});
}
//#endregion
export { ShiftFlagBadge };

//# sourceMappingURL=ShiftFlagBadge.js.map